// extracted by css-extract-rspack-plugin
export default {"row":"aHAcA","wrap":"pxBQm","nowrap":"CO3aW"};